/* eslint-disable react/no-children-prop */
import { Grid, Typography } from '@material-ui/core';
import { Text } from 'components/styleguide';

export const processingPrompt = (t) => {
  const content = (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      top: 55,
      width: '550px!',
      maxHeight: '400px',
      overflowY: 'auto',
    }
    }
    >
      <Typography sx={{ fontWeight: 'bold' }} variant="h6" color="textPrimary">
        {t('prompt.title')}
      </Typography>
      <Grid style={{ marginTop: '15px' }} xs={12}>
        <Text
          variant="formLabel"
          children={t('prompt.text')}
        />
      </Grid>

    </div>
  );

  return {
    content,
    multiOk: false,
    okLabel: t('prompt.close'),
    onlyOk: true,
  };
};
